import { render, staticRenderFns } from "./ShopFooter.vue?vue&type=template&id=4b0fea28&scoped=true"
import script from "./ShopFooter.vue?vue&type=script&lang=js"
export * from "./ShopFooter.vue?vue&type=script&lang=js"
import style0 from "./ShopFooter.vue?vue&type=style&index=0&id=4b0fea28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0fea28",
  null
  
)

export default component.exports